export const idGenerator = (name?: string): string => {
  const result = `${Date.now()}_${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
  return name ? `${name}_${result}` : `v2_${result}`;
};
